
import React from 'react';
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";

const ContactAdvisorCard: React.FC = () => {
  return (
    <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 space-y-3">
      <h3 className="font-medium text-amber-800">Potrzebujesz indywidualnej wyceny</h3>
      <p className="text-amber-700">
        Dla instalacji z więcej niż 10 pokojami oferujemy spersonalizowaną wycenę. 
        Skontaktuj się z naszym doradcą, aby otrzymać ofertę dopasowaną do Twoich potrzeb.
      </p>
      <Button className="flex items-center gap-2 bg-amber-600 hover:bg-amber-700">
        <Phone size={18} />
        <a href="tel:+48123456789">+48 123 456 789</a>
      </Button>
    </div>
  );
};

export default ContactAdvisorCard;
